import React, { useState, useEffect } from 'react';
import ClaimAttachments from './ClaimAttachments';

const TrackingAttachmentsSection = ({ trackingNumber }) => {
  const [isAttachmentsUpdated, setIsAttachmentsUpdated] = useState(false);

  // Ajout de logs pour déboguer le problème de trackingNumber
  useEffect(() => {
    console.log('TrackingAttachmentsSection - trackingNumber reçu:', trackingNumber);
  }, [trackingNumber]);

  const handleAttachmentsUpdated = () => {
    setIsAttachmentsUpdated(true);
    // Réinitialiser l'état après un délai pour permettre une notification visuelle
    setTimeout(() => setIsAttachmentsUpdated(false), 3000);
  };

  // Si pas de trackingNumber, afficher un message
  if (!trackingNumber) {
    return (
      <div className="mt-4 alert alert-warning">
        Impossible de gérer les pièces jointes : numéro de suivi manquant.
      </div>
    );
  }

  return (
    <div className="mt-4">
      <ClaimAttachments
        trackingNumber={trackingNumber}
        onAttachmentsUpdated={handleAttachmentsUpdated}
      />
    </div>
  );
};

export default TrackingAttachmentsSection;